const lightRedOrche = '#EC6350'
const lightSeaGreen = '#20A39E'
const mineShaft = '#262626'
const tundora = '#484848'
const dimGrey = '#707070'
const alto = '#D1D1D1'
const darkPastelGreen = '#5CA320'
const valencia = '#D63E29'

export const white = '#ffffff'
export const black = '#262626'
export const brandColor = lightRedOrche
export const highlightColor = lightSeaGreen
export const headersColor = mineShaft
export const subtitlesColor = tundora
export const primaryTextColor = dimGrey
export const suggestiveColor = alto
export const confirmationColor = darkPastelGreen
export const errorColor = valencia
